import { Stack } from "~/common/mui";
import SearchResultSkeleton from "./SearchResultSkeleton";
import type { ReactNode } from "react";

interface SkeletonResultListProps {
  amount: number;
  recommendationPosition?: number;
  recommendationComponent?: ReactNode;
}

export const SkeletonResultList = ({
  amount,
  recommendationPosition,
  recommendationComponent,
}: SkeletonResultListProps) => {
  const rows: ReactNode[] = Array.from({ length: amount }).map((_, index) => <SearchResultSkeleton key={index} />);

  if (typeof recommendationPosition === "number" && recommendationComponent) {
    rows.splice(recommendationPosition, 0, recommendationComponent);
  }

  return (
    <Stack gap={2} component={"ul"} sx={{ paddingLeft: 0 }}>
      {rows}
    </Stack>
  );
};
